// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sustainable-component .title[data-v-0273f0f9] {\r\n        color: black;\r\n        background-color: white;\r\n        position: absolute;\r\n        top: -18px;\r\n        left: 14px;\r\n        width: -moz-fit-content;\r\n        width: fit-content;\r\n        font-size: 12px;\r\n        font-weight: 400\n}\r\n\r\n    \r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
